import * as S from "./styles";
import { ReactComponent as CarIcon } from "assets/car.svg";
import { ReactComponent as HomeIcon } from "assets/home.svg";
import { ReactComponent as HeartIcon } from "assets/heart-like.svg";
import { IMapLocationData } from "contexts/map/types";
import { useGlobalMapActions } from "contexts/map";

export type MarkerCardProps = {
  marker: IMapLocationData;
  isSelected?: boolean;
  onMapLocationChange: (coords: { lat: number; lng: number }) => void;
  onMoreDetailsClick: (occurrenceId: string) => void;
  onFavoriteClick: () => void;
};

export function OccurrenceMarkerCard({
  marker,
  isSelected,
  onMapLocationChange,
  onMoreDetailsClick,
  onFavoriteClick,
}: MarkerCardProps) {
  const { coords, dataId, name, type, isFavorite, working } = marker;

  const { handleMoreDetailClick } = useGlobalMapActions();

  const Icon = type === "vehicle" ? <CarIcon /> : <HomeIcon />;

  function handleSeeOnMapClick() {
    onMapLocationChange(coords);
  }

  return (
    <S.OccurrenceMarkerWrapper selected={isSelected}>
      <header>
        <S.HeaderBody>
          <S.IconContainer>{Icon}</S.IconContainer>
          <S.TextContainer>
            <h4>{name}</h4>
            <h4 onClick={handleSeeOnMapClick}>
              {coords.lat}, {coords.lng}
            </h4>
          </S.TextContainer>
        </S.HeaderBody>
        <S.HeaderFooter>
          <S.HeaderBadge working={working}>
            <span>
              {working ? "Em andamento" : "Aguardando pronta-resposta"}
            </span>
          </S.HeaderBadge>
        </S.HeaderFooter>
      </header>

      <S.OccurrenceMarkerBody>
        <S.FavoriteButton favorite={isFavorite} onClick={onFavoriteClick}>
          <HeartIcon />
        </S.FavoriteButton>
        <button onClick={() => onMoreDetailsClick(dataId)}>Gerenciar</button>
        <button
          onClick={() => {
            handleMoreDetailClick(dataId);
          }}
        >
          Ver detalhes
        </button>
        <button onClick={handleSeeOnMapClick}>Ver no mapa</button>
      </S.OccurrenceMarkerBody>
    </S.OccurrenceMarkerWrapper>
  );
}
